import { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SponsoredSolarRouter } from '~/funnels/routing/sponsored-solar';
import { FunnelRoutes } from '~/funnels/routing/sponsored-solar/types';
import { INTERNAL_ROUTES } from '~/utils/constants';
import { trackError } from '~/utils/tracking';

export interface RouterContextState {
  nextRoute: FunnelRoutes;
  loading: boolean;
}

export const RouterContext = createContext({} as RouterContextState);
export const SponsoredSolarRouterProvider = ({ children }) => {
  const navigate = useNavigate();
  const [routerState, setRouterState] = useState({
    loading: true,
  } as RouterContextState);

  useEffect(() => {
    SponsoredSolarRouter.getNextRoute()
      .then(nextRoute => {
        setRouterState(prevState => {
          return {
            ...prevState,
            loading: false,
            nextRoute: nextRoute!,
          };
        });
      })
      .finally(() => {
        setRouterState(prevState => {
          return {
            ...prevState,
            loading: false,
          };
        });
      })
      .catch(error => {
        trackError(error);
        navigate(INTERNAL_ROUTES.SPONSORED_SOLAR);
        setRouterState(prevState => {
          return {
            ...prevState,
            nextRoute: INTERNAL_ROUTES.SPONSORED_SOLAR as FunnelRoutes,
            loading: false,
          };
        });
      });
  }, []);
  return <RouterContext.Provider value={routerState}>{children}</RouterContext.Provider>;
};
